import { useTheme, Container, Stack, Typography, Grow } from "@mui/material";
import ThumbsUp from "assets/images/icons/thumbsup.svg";
import ThumbsUpdark from "assets/images/icons/thumbsup-dark.svg";

const LastStep = () => {
    const theme = useTheme();

    return (
        <Container maxWidth="md" sx={{ mt: 4, mb: 2 }}>
            <Stack alignItems="center" gap={2}>
                <Grow in timeout={1000}>
                    <img
                        src={
                            theme.palette.mode === "light"
                                ? ThumbsUp
                                : ThumbsUpdark
                        }
                        alt="Thumbs Up"
                    />
                </Grow>
                <Typography variant="h3" color="secondary" fontSize={24}>
                    Well Done!
                </Typography>
                <Typography fontWeight="500" color="text.mediumDark">
                    Thank you for sharing your information. Click{" "}
                    <Typography
                        color="secondary"
                        display="inline"
                        fontWeight="inherit"
                    >
                        Complete
                    </Typography>{" "}
                    to finish
                </Typography>
            </Stack>
        </Container>
    );
};

export default LastStep;
